<template>
    <div class="search-input-component">
        <b-icon-search class="icon" />
        <b-input
            class="input"
            type="text"
            v-model="text"
            v-on:change="textChanged"
            v-on:focusout="focusOutHandler"
            :placeholder="this.$t('search.placeholder')"
        />
        <b-icon-x
            v-if="text.length"
            class="icon-clear"
            scale="1.5"
            @click="clearText"
        />
    </div>
</template>

<script>
export default {
    name: "SearchInput",
    props: {
        onTextChanged: { required: true },
    },
    data() {
        return {
            text: '',
        };
    },
    methods: {
        textChanged() {
            if (this.onTextChanged) {
                this.onTextChanged(this.text);
            }
        },
        focusOutHandler() {

        },
        clearText() {
            this.text = '';
            this.textChanged();
        }
    }
}
</script>

<style lang="scss" scoped>

    .search-input-component {

        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 100%;

        .icon {
            position: absolute;
            display: block;
            margin-left: 12px;
        }

        .input {
            padding-left: 34px;
            padding-right: 34px;
        }

        .icon-clear {
            position: absolute;
            display: block;
            right: 0;
            margin-right: 26px;


            &:hover {
                cursor: pointer;
            }
        }
    }

</style>